/* Lettoria wallet clearance LP — detail sheet module (loaded before the main picker script).
 * Exposes window.LTWSheet = { open(p), refresh(), isOpen() }. The main script hands it a `ctx` at init:
 *   ctx.count(p) · ctx.pricing() · ctx.full() · ctx.paidN() · ctx.picks · ctx.stepper(p, cls) · ctx.chapters · ctx.facts
 * Bottom sheet on phone, centred dialog on desktop; chat bubbles (bare fixed <button>) hidden while open. */
(function () {
  var root = document.querySelector('[data-ltw]');
  if (!root) return;
  var el = root.querySelector('[data-ltw-sheet]');
  var $ = function (sel) { return root.querySelector(sel); };
  var state = { open: false, p: null, last: null, ctx: null };
  var money = function (n) { return '$' + n.toFixed(2); };

  function bubbles() {
    var found = [], btns = document.querySelectorAll('body > button, body > div > button');
    for (var i = 0; i < btns.length; i += 1) {
      var cs = window.getComputedStyle(btns[i]);
      if (cs.position !== 'fixed' || btns[i].closest('[data-ltw-sticky]')) continue;
      var r = btns[i].getBoundingClientRect();
      if (r.bottom > window.innerHeight - 100 && r.right > window.innerWidth - 100) found.push(btns[i]);
    }
    return found;
  }

  function fill() {
    var p = state.p, ctx = state.ctx; if (!p || !ctx) return;
    var c = ctx.count(p), pr = ctx.pricing(), paidIdx = pr.paidIdx;
    var isPaid = ctx.picks.some(function (x, i) { return x === p && paidIdx.indexOf(i) > -1; });
    $('[data-ltw-sheet-eyebrow]').textContent = c
      ? (isPaid ? 'In your set · this is the one you pay for' : 'In your set · FREE')
      : (ctx.full() ? 'Your set is full · remove one to swap this in' : 'Not in your set yet · ' + (ctx.picks.length < ctx.paidN() ? 'this one you pay for' : 'this one is FREE'));
    var box = $('[data-ltw-sheet-stepper]'); box.innerHTML = ''; box.appendChild(ctx.stepper(p, 'is-big'));
  }

  function open(p, ctx) {
    state.p = p; state.ctx = ctx; state.open = true; state.last = document.activeElement;
    var imgs = [p.img, p.img2].filter(Boolean);
    var stage = $('[data-ltw-sheet-img]'); stage.src = imgs[0]; stage.alt = p.n; stage.classList.remove('is-photo'); // img[0] = packshot (band crop), img[1+] = lifestyle photo (contain)
    var th = $('[data-ltw-sheet-thumbs]'); th.innerHTML = ''; th.hidden = imgs.length < 2;
    imgs.forEach(function (src, k) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('data-hc-el', 'gallery-thumb'); b.setAttribute('aria-current', String(k === 0));
      if (k > 0) b.className = 'is-photo';
      b.innerHTML = '<img src="' + src + '" alt="">';
      b.addEventListener('click', function () { stage.src = src; stage.classList.toggle('is-photo', k > 0); th.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-current', String(x === b)); }); });
      th.appendChild(b);
    });
    $('[data-ltw-sheet-title]').textContent = p.n + (p.form === 'mini' ? ' Mini Wallet' : ' Wallet');
    var st = $('[data-ltw-sheet-statement]'); st.textContent = p.st || ''; st.hidden = !p.st;
    var f = ctx.facts[p.form] || ctx.facts.wallet || [], rows = '';
    if (f[0]) rows += '<div><dt>Size</dt><dd>' + f[0] + '</dd></div>';
    if (f[1]) rows += '<div><dt>Holds</dt><dd>' + f[1] + '</dd></div>';
    if (ctx.facts.material) rows += '<div><dt>Material</dt><dd>' + ctx.facts.material + '</dd></div>';
    if (p.v) rows += '<div><dt>Colorway</dt><dd>' + p.v + '</dd></div>'; // colourway split off the title by the picker script
    rows += '<div><dt>Chapter</dt><dd>' + (p.ch || ctx.chapters[p.reg] || '') + '</dd></div><div><dt>Sold apart</dt><dd>' + money(p.price) + '</dd></div>';
    $('[data-ltw-sheet-facts]').innerHTML = rows;
    $('[data-ltw-sheet-link]').href = p.url;
    fill();
    el.hidden = false; document.body.classList.add('ltw-sheet-open');
    bubbles().forEach(function (b) { b.style.setProperty('visibility', 'hidden', 'important'); b.__ltwHid = true; });
    requestAnimationFrame(function () { el.classList.add('is-on'); $('.ltw-sheet__panel').focus(); });
  }

  function close() {
    if (!state.open) return;
    state.open = false; el.classList.remove('is-on'); document.body.classList.remove('ltw-sheet-open');
    setTimeout(function () { el.hidden = true; }, 220);
    document.querySelectorAll('body > button, body > div > button').forEach(function (b) { if (b.__ltwHid) { b.style.removeProperty('visibility'); b.__ltwHid = false; } });
    if (state.last && state.last.focus) state.last.focus();
  }

  root.querySelectorAll('[data-ltw-sheet-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.LTWSheet = { open: open, refresh: fill, isOpen: function () { return state.open; } };
})();
